<div class="guesses pt-2">
  <app-city-guess *ngFor="let guess of guesses$ | async" [guess]="guess"></app-city-guess>
  <app-city-input></app-city-input>
</div>
